// extracted by mini-css-extract-plugin
export default {"link":"d5pO84mAQL0XREMEWry4"};